import i18next from 'i18next';

i18next.addResources('en', 'PlayButton', {
  play: 'Play'
});

i18next.addResources('fr', 'PlayButton', {
  play: 'Venez Jouer!'
});

i18next.addResources('it', 'PlayButton', {
  play: 'È l’ora di divertirsi!'
});

i18next.addResources('de', 'PlayButton', {
  play: 'Spielen'
});

i18next.addResources('zh', 'PlayButton', {
  play: '播放（发音）'
});

i18next.addResources('zt', 'PlayButton', {
  play: '播放（發音）'
});

i18next.addResources('es', 'PlayButton', {
  play: 'Reproducir'
});

i18next.addResources('pt', 'PlayButton', {
  play: 'Reproduzir'
});

i18next.addResources('ja', 'PlayButton', {
  play: '再生'
});

i18next.addResources('ru', 'PlayButton', {
  play: 'Воспроизвести'
});

i18next.addResources('ar', 'PlayButton', {
  play: 'تشغيل'
});

i18next.addResources('hi', 'PlayButton', {
  play: 'चलाएं'
});
